import { Box, Typography } from '@mui/material';

import type { TitleKeys } from 'pages/ParentHelper/components/History/components/Content/types';
import type { FC, PropsWithChildren, ReactNode } from 'react';

interface ChatTopicsWrapperProps extends PropsWithChildren {
  title: ReactNode;
  titleKey?: TitleKeys;
}

export const ChatTopicsWrapper: FC<ChatTopicsWrapperProps> = ({
  title,
  children,
  titleKey,
}) => (
  <Box sx={{ mt: { xs: 1, md: 3 } }} id={titleKey}>
    <Typography>{title}</Typography>
    {children}
  </Box>
);
